module.exports = __webpack_public_path__ + "img/code-arrow.ad7a67e3.png";